module.exports = __webpack_public_path__ + "static/people.3b02af1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/people.jpg
// module id = 534
// module chunks = 193747675109532